/**
 * Restaurant-only feature gating helpers.
 * Magasin / épicerie / etc. must not pick up restaurant POS/COGS semantics.
 */

import { isRestaurantBusinessType } from '../../utils/restaurantMode';
import { RESTAURANT_SALE_TYPE } from './restaurantDishSaleService';

export function resolveBusinessTypeFromParsed(parsed) {
  if (!parsed || typeof parsed !== 'object') return null;
  return (
    parsed.businessInfo?.business_type ||
    parsed.businessInfo?.businessType ||
    parsed.metadata?.business_type ||
    parsed.businessType ||
    null
  );
}

/** Persist / prefer sale.inventoryCost only for restaurant businesses. */
export function shouldPersistSaleInventoryCost(parsed, options = {}) {
  if (options.forceRestaurantInventoryCost === true) return true;
  if (isRestaurantBusinessType(options.businessType)) return true;
  return isRestaurantBusinessType(resolveBusinessTypeFromParsed(parsed));
}

/**
 * True when a sale record is restaurant-scoped (dish sale or dish lines).
 * Pure stock sales in a restaurant business rely on inventoryCost being set
 * only at persist time for that business — resolveSaleInventoryCogs then trusts the field.
 */
export function isRestaurantScopedSale(sale) {
  if (!sale) return false;
  if (sale.saleType === RESTAURANT_SALE_TYPE) return true;
  if (Array.isArray(sale.dishes) && sale.dishes.length > 0) return true;
  const products = Array.isArray(sale.products) ? sale.products : [];
  return products.some(
    (p) =>
      p?.isRestaurantDish === true ||
      p?.productRole === 'restaurant_dish'
  );
}
